import { extractSuggestionsAndContent } from './chatMessageParsing';
import { PARTS_FLOW_ENABLED } from '../config/features';

const cleanDisplayText = (value = '') => String(value || '').replace(/\s+/g, ' ').trim();

export const GARAGE_RESPONSE_SUGGESTIONS = [
    'Diagnose an Issue',
    ...(PARTS_FLOW_ENABLED ? ['Find Parts'] : []),
    'Log a Service',
    'Maintenance Due?',
];

export const isGarageVehicleListResponse = (text = '') => {
    const content = cleanDisplayText(extractSuggestionsAndContent(text || '').content).toLowerCase();
    if (!content) return false;
    return (
        content.startsWith('here are the vehicles registered in your account') ||
        content.startsWith('you do not have any vehicles registered yet')
    );
};
